<template>
    <div class="flex flex-col flex-wrap">
    <div class="w-full list-actor-row flex flex-row flex-wrap overflow-hidden">
    <swiper v-bind="getSwiperParameters" class="swiper-container">
        <swiper-slide v-for="(item, i) in dataArtists" :key="i">
           <actor-swiper :actor="item"></actor-swiper>
        </swiper-slide>
    </swiper>
    </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Virtual } from "swiper";
import "swiper/css/navigation";
import "swiper/css";
import "swiper/css/navigation";
import "../MySwiper.css";

export default {
    name: "carousel-swiper",
    inject: ["mq"],
    components:{
        Swiper,
        SwiperSlide
    },
    props: {
        dataArtists: {
            type: Array,
            default: []
        }
    },
    computed: {
        getSwiperParameters() {
            return {
                modules: [Navigation, Virtual],
                speed: 1200,
                slidesPerView:1,
                navigation: true,
                autoHeight: true,
                freemode:true,
                breakpoints:{
                    '1024':{
                        slidesPerView: 3,
                        spaceBetween:5,
                        height:500
                    },
                    '2560':{
                        slidesPerView:4,
                        spaceBetween: 5,
                        height: 600
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>